export const environment = {
  production: false,
  env: "qa",
  apiHost: "https://api.qa-staging.zceppa.com/",
  pusher: {
    key: "e25692894f683359a2ae",
    cluster: "ap2",
  }
};
